module.exports = __webpack_public_path__ + "static/media/performance-icon.9dacf4c3.svg";